import { __decorate } from "tslib";
import { LitElement, css, html, property, customElement, internalProperty } from 'lit-element';
import { baseStyles } from './styles';
import { styleMap } from 'lit-html/directives/style-map.js';
import { getTabableItems } from './utils';
let CdsGridCell = class CdsGridCell extends LitElement {
    constructor() {
        super(...arguments);
        this.active = false;
        this.col = null;
        this.row = null;
        this.firstCell = false;
    }
    createRenderRoot() {
        return this.attachShadow({ mode: 'open', delegatesFocus: true });
    }
    static get styles() {
        return [baseStyles, css `
      :host {
        display: contents;
        --background: var(--cds-alias-object-container-background);
        --border-top: var(--cds-alias-object-border-width-100) solid var(--cds-alias-object-border-color);
      }

      td {
        background: var(--background);
        border-width: 0;
        border-style: solid;
        border-color: var(--cds-alias-object-border-color);
        font-size: 14px;
        text-align: left;
        margin: 0;
        display: flex;
        gap: var(--cds-global-space-3);
        padding: var(--cds-global-space-5) var(--cds-global-space-6) var(--cds-global-space-5) var(--cds-global-space-6);
        min-height: var(--cds-global-space-11);
        line-height: 1em;
        align-items: center;
        width: 100%;
        height: 100%;
        border-top: var(--border-top);
        outline-offset: -2px;
        color: var(--cds-global-typography-color-500);
      }

      ::slotted(cds-inline-button[drag-handle]) {
        -webkit-user-drag: element !important;
        user-select: none !important;
        --cursor: move !important; /* need to expose from base element styles */
        --font-size: 30px;
        --padding: 0;
        margin: -4px 0 0 -10px;
      }

      ::slotted(cds-inline-button) {
        --color: var(--cds-global-typography-color-500);
        --padding: 0;
      }

      :host([position='fixed']) th {
        position: fixed;
        border-right-width: 1px;
      }
    `];
    }
    get td() {
        return this.shadowRoot.querySelector('td');
    }
    render() {
        return html `
      <td tabindex="0" role="cell" aria-colindex=${this.col + 1} style=${styleMap({
            position: `var(--col-${this.col}-position)`,
            left: `var(--col-${this.col}-left, initial)`,
            borderRightWidth: `var(--col-${this.col}-border-width, 0)`
        })}>
          <slot></slot>
      </td>
    `;
    }
    updated(props) {
        super.updated(props);
        if (props.has('active')) {
            if (this.active) {
                this.removeAttribute('tabindex');
                getTabableItems(this).length === 1 ? this.td.removeAttribute('tabindex') : this.td.setAttribute('tabindex', '0');
                if (!this.firstCell) {
                    this.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
                    this.focus();
                }
                else {
                    this.firstCell = false;
                }
            }
            else {
                this.setAttribute('tabindex', '-1');
            }
        }
    }
};
__decorate([
    property({ type: Boolean, reflect: true })
], CdsGridCell.prototype, "active", void 0);
__decorate([
    internalProperty()
], CdsGridCell.prototype, "col", void 0);
__decorate([
    internalProperty()
], CdsGridCell.prototype, "row", void 0);
__decorate([
    internalProperty()
], CdsGridCell.prototype, "firstCell", void 0);
CdsGridCell = __decorate([
    customElement('cds-grid-cell')
], CdsGridCell);
export { CdsGridCell };
//# sourceMappingURL=grid-cell.element.js.map